import React, { useState, useEffect } from 'react'
import cx from 'classnames';
import { Link } from 'gatsby';
import Layout from 'src/components/layout';
import Bottom from 'src/components/Bottom';
import _get from 'lodash/get';
import { navigate } from 'gatsby';
// import { dashboard } from 'src/helpers';
import { getStatsPool } from 'src/helpers/api/api';
import gs from './pages.module.css';
import { HOME_PATHES, HOME_STORAGE_NAME } from 'src/constants/index'
import storage from '../helpers/storage';

import styles from './errorBoundary.module.css';
import pageStyles from './pages.module.css';
import errorPageImage from 'src/utils/images/error_page.svg'

const IndexPage = props => {
  const getPageForMeta = () => {
    const { coin } = props;
    return coin === 'ETC' ? coin.toLowerCase() : 'default'
  }

  return (
    <Layout page={getPageForMeta()}>

      <section className={[pageStyles.content, pageStyles.top, pageStyles.notFound].join(' ')}>
        <div className={[pageStyles.wrapper, pageStyles.wrapperNotFound].join(' ')}>
          <div className={styles.intro}>
            <div className={styles.msg}>
              {false && <h1 className={styles.accent}>Sorry, site is under maintenance.</h1>}
              <h1 className={styles.accent}>Not to worry, we're upgrading our infrastructure.</h1>
              {false && <h4 style={{ marginBottom: '20px' }}>No worries, we’re upgrading our infrastructure.</h4>}
              <h4 style={{fontSize: '30px', marginBottom: '50px'}}>This doesn't affect mining, and all shares still count.</h4>
            </div>
            {false && <div className={styles.buttonsContainer}>
              <button onClick={() => window.location.reload()} className={styles.button}
              >
                Reload
              </button>
            </div>}
          </div>
          <div className={styles.imageContainer}>
            <img src={errorPageImage} alt="error" className={styles.image} />
          </div>
        </div>
      </section>

      <Bottom />
    </Layout>
  )
}


export default IndexPage;
